import { render, staticRenderFns } from "./materialConsumption.vue?vue&type=template&id=609f952b&scoped=true"
import script from "./materialConsumption.vue?vue&type=script&lang=js"
export * from "./materialConsumption.vue?vue&type=script&lang=js"
import style0 from "./materialConsumption.vue?vue&type=style&index=0&id=609f952b&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_21c2e229d51f918cc63b499183bc63cd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609f952b",
  null
  
)

export default component.exports